(function () {
  var STATE_KEY = 'asc_insurance_checkout_optin';

  /* -------------------------
     HELPERS
  --------------------------*/
  function getRoot() {
    return document.getElementById('asc-root-shipping-insurance');
  }

  function getVariantId() {
    var root = getRoot();
    return root ? Number(root.dataset.variantId) : null;
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function addInsurance(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    });
  }

  function removeInsurance(cart, id) {
    var items = cart.items.filter(function (i) { return i.variant_id === id; });
    return Promise.all(items.map(function (item) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      });
    }));
  }

  function updateUI(enabled) {
    var root = getRoot();
    var toggle = document.getElementById('shipping-insurance-toggle');
    var text = document.getElementById('shipping-insurance-text');
    var svg = document.querySelector('svg.asc-widget-image-1766921464');
    if (!root) return;

    if (toggle) toggle.checked = enabled;
    if (text) text.innerHTML = enabled ? root.dataset.enabledText : root.dataset.disabledText;
    if (svg) svg.style.filter = enabled ? 'grayscale(0)' : 'grayscale(1)';
  }

  // The widget may not exist on every page — mirror the toggle state in
  // sessionStorage so the checkout intercept always knows the decision.
  function isOptedIn() {
    var toggle = document.getElementById('shipping-insurance-toggle');
    if (toggle) return toggle.checked;
    return sessionStorage.getItem(STATE_KEY) !== '0';
  }

  function saveState(enabled) {
    try {
      sessionStorage.setItem(STATE_KEY, enabled ? '1' : '0');
    } catch (e) {}
  }

  /* -------------------------
     INIT — always start enabled, toggle only changes UI
  --------------------------*/
  document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.getElementById('shipping-insurance-toggle');
    if (!toggle) return;

    // Always ON at load, regardless of previous visits
    updateUI(true);
    saveState(true);

    toggle.addEventListener('change', function () {
      updateUI(toggle.checked);
      saveState(toggle.checked);

      // Only cart cleanup allowed before checkout: if switched OFF and a
      // leftover insurance item exists (e.g. abandoned checkout), remove it.
      if (!toggle.checked) {
        var id = getVariantId();
        if (!id) return;
        getCart().then(function (cart) {
          var exists = cart.items.some(function (i) { return i.variant_id === id; });
          if (exists) {
            removeInsurance(cart, id).then(function () {
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', { bubbles: true })
              );
            });
          }
        });
      }
    });
  });

  /* -------------------------
     CHECKOUT INTERCEPT — the only place insurance gets ADDED
  --------------------------*/
  document.addEventListener('click', function (e) {
    var btn = e.target.closest(
      'button[name="checkout"], input[name="checkout"], a[href="/checkout"], a[href^="/checkout?"]'
    );
    if (!btn) return;

    var id = getVariantId();
    if (!id) return;

    // Let the click through untouched; we already handled the cart
    if (btn.dataset.ascInsuranceReady === '1') {
      delete btn.dataset.ascInsuranceReady;
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    getCart().then(function (cart) {
      var exists = cart.items.some(function (i) { return i.variant_id === id; });
      var wantsInsurance = isOptedIn();

      var prepare;
      if (wantsInsurance && !exists) {
        prepare = addInsurance(id);
      } else if (!wantsInsurance && exists) {
        prepare = removeInsurance(cart, id);
      } else {
        prepare = Promise.resolve();
      }

      return prepare.then(function () {
        // Re-fire the original action with the cart now correct
        btn.dataset.ascInsuranceReady = '1';
        btn.click();
      });
    }).catch(function () {
      // Cart API failed — don't block the shopper from checking out
      btn.dataset.ascInsuranceReady = '1';
      btn.click();
    });
  }, true);
})();





// geo-location
const countryFlags = {
  'US': '🇺🇸',
  'CA': '🇨🇦',
  'FR': '🇫🇷',
  'NL': '🇳🇱',
  'DE': '🇩🇪',
  'GB': '🇬🇧',
  'IT': '🇮🇹',
  'ES': '🇪🇸',
  'CN': '🇨🇳',
  'JP': '🇯🇵',
  'BR': '🇧🇷',
  'IN': '🇮🇳',
  'RU': '🇷🇺',
  'ZA': '🇿🇦',
  'AU': '🇦🇺',
  'NZ': '🇳🇿',
  'MX': '🇲🇽',
  'AR': '🇦🇷',
  'CL': '🇨🇱',
  'CO': '🇨🇴',
  'PE': '🇵🇪',
  'VE': '🇻🇪',
  'EC': '🇪🇨',
  'GT': '🇬🇹',
  'HN': '🇭🇳',
  'SA': '🇸🇦',
  'AE': '🇦🇪',
  'TR': '🇹🇷',
  'TH': '🇹🇭',
  'MY': '🇲🇾',
  'SG': '🇸🇬',
  'ID': '🇮🇩',
  'PH': '🇵🇭',
  'VN': '🇻🇳',
  'KR': '🇰🇷',
  'KP': '🇰🇵',
  'SE': '🇸🇪',
  'NO': '🇳🇴',
  'FI': '🇫🇮',
  'DK': '🇩🇰',
  'IS': '🇮🇸',
  'IE': '🇮🇪',
  'CH': '🇨🇭',
  'PT': '🇵🇹',
  'BE': '🇧🇪',
  'LU': '🇱🇺',
  'PL': '🇵🇱',
  'CZ': '🇨🇿',
  'SK': '🇸🇰',
  'HU': '🇭🇺',
  'AT': '🇦🇹',
  'LI': '🇱🇮',
  'GR': '🇬🇷',
  'BG': '🇧🇬',
  'RO': '🇷🇴',
  'UA': '🇺🇦',
  'BY': '🇧🇾',
  'LT': '🇱🇹',
  'LV': '🇱🇻',
  'EE': '🇪🇪',
  'MD': '🇲🇩',
  'AM': '🇦🇲',
  'GE': '🇬🇪',
  'AZ': '🇦🇿',
  'IR': '🇮🇷',
  'IQ': '🇮🇶',
  'SY': '🇸🇾',
  'LB': '🇱🇧',
  'JO': '🇯🇴',
  'IL': '🇮🇱',
  'EG': '🇪🇬',
  'MA': '🇲🇦',
  'DZ': '🇩🇿',
  'TN': '🇹🇳',
  'LY': '🇱🇾',
  'GM': '🇬🇲',
  'SN': '🇸🇳',
  'MR': '🇲🇷',
  'ML': '🇲🇱',
  'GN': '🇬🇳',
  'CI': '🇨🇮',
  'BF': '🇧🇫',
  'NE': '🇳🇪',
  'TG': '🇹🇬',
  'BJ': '🇧🇯',
  'NG': '🇳🇬',
  'CM': '🇨🇲',
  'GA': '🇬🇦',
  'CG': '🇨🇬',
  'CD': '🇨🇩',
  'AO': '🇦🇴',
  'GW': '🇬🇼',
  'SC': '🇸🇨',
  'SD': '🇸🇩',
  'RW': '🇷🇼',
  'ET': '🇪🇹',
  'SO': '🇸🇴',
  'DJ': '🇩🇯',
  'KE': '🇰🇪',
  'TZ': '🇹🇿',
  'UG': '🇺🇬',
  'BI': '🇧🇮',
  'MZ': '🇲🇿',
  'ZM': '🇿🇲',
  'MW': '🇲🇼',
  'LS': '🇱🇸',
  'BW': '🇧🇼',
  'NA': '🇳🇦',
  'ZA': '🇿🇦',
  'SZ': '🇸🇿',
  'PK': '🇵🇰'
};


const LOCATION_STORAGE_KEY = 'userLocationInfo';

function setLocationInfo(countryCode, countryName) {
  const flagEmoji = countryFlags?.[countryCode];

  document.body.style.setProperty(
    '--shipping-cntry-emoji-cstmm',
    `"${flagEmoji}"`
  );

  document.body.style.setProperty(
    '--shipping-message-cstmm',
    `"${countryName}"`
  );

  // Save to localStorage
  localStorage.setItem(
    LOCATION_STORAGE_KEY,
    JSON.stringify({ countryCode, countryName })
  );
}

function loadLocationFromStorage() {
  const stored = localStorage.getItem(LOCATION_STORAGE_KEY);
  if (!stored) return;

  try {
    const { countryCode, countryName } = JSON.parse(stored);
    if (countryName) {
      setLocationInfo(countryCode, countryName);
    }
  } catch (e) {
    console.warn('Invalid location data in localStorage');
  }
}

async function fetchLocationInfo() {
  try {
    const response = await fetch('/browsing_context_suggestions.json');
    const data = await response.json();

    const countryCode = data.detected_values.country.handle;
    const countryName = data.detected_values.country.name;

    // Only update if different from stored value
    const stored = localStorage.getItem(LOCATION_STORAGE_KEY);
    const storedData = stored ? JSON.parse(stored) : {};

    if (
      storedData.countryCode !== countryCode ||
      storedData.countryName !== countryName
    ) {
      setLocationInfo(countryCode, countryName);
    }
  } catch (error) {
    console.error('Error fetching location info:', error);
  }
}

loadLocationFromStorage();
fetchLocationInfo();